module.exports = "<p>\n  Welcome to our Home Page!!\n  Authenticated = {{bAuthenticated}}\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main